import { createContext, useContext } from 'react';

import { DEFAULT_TIME_COMMITMENT } from 'bundles/adaptive-learning-common/constants';
import type { AdaptiveLearningPlan, LearningBlock, TimeCommitment } from 'bundles/adaptive-learning-common/types';

export type AdaptiveLearningContextType = {
  isEnabled: boolean;
  show: boolean;
  loading: boolean;
  setShow: (show: boolean) => void;
  adaptivePlan?: AdaptiveLearningPlan;
  timeCommitment: TimeCommitment;
  getLearningBlock: (itemId: string) => LearningBlock | undefined;
  updatePlan: (plan: AdaptiveLearningPlan) => void;
  regeneratePlan: (timeCommitment: TimeCommitment) => Promise<void>;
  refetchPlan: () => Promise<void>;
  isProgressDialogOpen: boolean;
  setIsProgressDialogOpen: (open: boolean) => void;
};

export const AdaptiveLearningContext = createContext<AdaptiveLearningContextType>({
  isEnabled: false,
  show: false,
  loading: false,
  setShow: () => undefined,
  timeCommitment: DEFAULT_TIME_COMMITMENT,
  getLearningBlock: () => undefined,
  updatePlan: () => undefined,
  regeneratePlan: () => Promise.resolve(),
  isProgressDialogOpen: false,
  setIsProgressDialogOpen: () => undefined,
  refetchPlan: () => Promise.resolve(),
});

export const useAdaptiveLearningContext = () => useContext(AdaptiveLearningContext);
